import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { GapRentalForm } from "@/app/GapRentals/Forms/GapRentalForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateRelocationMutation } from "@/app/Relocations/GraphQL/relocationMutations";
import { getGapRentalUpdateInput } from "@/app/GapRentals/Utils/getGapRentalUpdateInput";
import { GapRentalFormValues } from "@/app/GapRentals/Utils/getDefaultGapRentalValues";
import { toGapRentalInput } from "@/app/GapRentals/Utils/gapRentalDistance";
import { gapRentalValidation } from "@/app/GapRentals/Validation/gapRentalValidation";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { useRelocation } from "@/app/Relocations/Hooks/useRelocation";

export function GapRentalEditDialog({
  id,
  onSuccess,
}: {
  id: string;
  onSuccess?: () => Promise<void> | void;
}) {
  const gapRental = useRelocation(id);

  const { mutateAsync } = useGqlMutation(updateRelocationMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog title="Edit gap rental">
      <GenericForm<GapRentalFormValues>
        validationSchema={toFormikValidationSchema(gapRentalValidation)}
        onSubmit={async (values) => {
          await mutateAsync({
            id: gapRental.id,
            input: toGapRentalInput(values),
          });

          await onSuccess?.();
          await close();
        }}
        initialValues={getGapRentalUpdateInput(gapRental)}
      >
        <GapRentalForm />
        <DialogSubmitButton text={"Save"} />
      </GenericForm>
    </BaseDialog>
  );
}
